import { render, staticRenderFns } from "./card-tab-with-content-losaprily.vue?vue&type=template&id=e0135bd8&scoped=true&"
import script from "./card-tab-with-content-losaprily.vue?vue&type=script&lang=js&"
export * from "./card-tab-with-content-losaprily.vue?vue&type=script&lang=js&"
import style0 from "./card-tab-with-content-losaprily.vue?vue&type=style&index=0&id=e0135bd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0135bd8",
  null
  
)

export default component.exports